import { useReducer, useCallback } from 'react';

export const FILE_STATUS = {
  REMOVED: 'REMOVED',
  REJECTED_FILE_TYPE: 'REJECTED_FILE_TYPE',
  PREPARING: 'PREPARING',
  DONE: 'DONE',
};

const initialState = {
  csvFile: null,
  fileStatus: FILE_STATUS.REMOVED,
  sourceOrg: '',
  snackbar: {
    open: false,
    severity: 'error',
    message: '',
  },
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_CSV_FILE':
      return {
        ...state,
        csvFile: action.payload,
      };
    case 'SET_FILE_STATUS':
      return {
        ...state,
        fileStatus: action.payload,
      };
    case 'SET_SOURCE_ORG':
      return {
        ...state,
        sourceOrg: action.payload,
      };
    case 'SET_SNACKBAR':
      return {
        ...state,
        snackbar: action.payload,
      };
    case 'RESET_STATE':
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const useLeadImportState = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setCsvFile = useCallback((file) => {
    dispatch({ type: 'SET_CSV_FILE', payload: file });
  }, []);

  const setFileStatus = useCallback((status) => {
    dispatch({ type: 'SET_FILE_STATUS', payload: status });
  }, []);

  const setSourceOrg = useCallback((sourceOrg) => {
    dispatch({ type: 'SET_SOURCE_ORG', payload: sourceOrg });
  }, []);

  const setSnackbar = useCallback((snackbar) => {
    dispatch({ type: 'SET_SNACKBAR', payload: snackbar });
  }, []);

  const resetState = useCallback(() => {
    dispatch({ type: 'RESET_STATE' });
  }, []);

  return {
    state,
    setCsvFile,
    setFileStatus,
    setSourceOrg,
    setSnackbar,
    resetState,
  };
};
